// 売却相談モーダル（参照デザイン: 旧サイト #pop_03）
const sellConsultModal = () => {
    const modal = document.querySelector('[data-sell-consult-modal]');
    if (!modal) return;

    const openers = document.querySelectorAll('[data-sell-consult-modal-open]');
    const closers = modal.querySelectorAll('[data-sell-consult-modal-close]');
    let lastFocus = null;

    const open = () => {
        lastFocus = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-sell-consult-modal-open');

        const toFocus = modal.querySelector('[data-sell-consult-modal-close]');
        toFocus?.focus({ preventScroll: true });
    };

    const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-sell-consult-modal-open');
        if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus({ preventScroll: true });
        }
    };

    openers.forEach((el) => {
        el.addEventListener('click', (e) => {
            // トリガーは <a href="#"> のためページ先頭へのスクロールを抑止
            e.preventDefault();
            open();
        });
    });

    closers.forEach((el) => {
        el.addEventListener('click', () => close());
    });

    // 白ボックスの外側（ラッパー自身＝オーバーレイ部分）クリックで閉じる
    modal.addEventListener('click', (e) => {
        if (e.target === modal) close();
    });

    // Escapeキーで閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (!modal.classList.contains('is-open')) return;
        close();
    });
};

export default sellConsultModal;
